export default {"src":"/_next/static/media/cs.509b3b0e.svg","height":600,"width":900};